export default __webpack_public_path__ + "static/media/pig.d86b86c7.svg";